import { useSaldo } from '../contexts/SaldoContext';

interface SaldoBadgeProps {
  className?: string;
}

export function SaldoBadge({ className = '' }: SaldoBadgeProps) {
  const { saldo, loading: saldoLoading, error: saldoError } = useSaldo();
  const temErro = saldoError && !saldoError.includes('Sessão expirada');

  return (
    <div className={`${temErro ? 'bg-red-100' : 'bg-blue-100'} ${className}`}>
      {saldoLoading ? (
        <span className="text-blue-700 text-base font-semibold mr-2">
          Saldo: <span className="animate-pulse">...</span>
        </span>
      ) : temErro ? (
        <span className="text-red-700 text-base font-semibold mr-2">
          Saldo: <span className="text-red-600">Erro</span>
        </span>
      ) : (
        <span className="text-blue-700 text-base font-semibold mr-2">Saldo: {saldo}</span>
      )}
    </div>
  );
}
